import { useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';
import { getPropertyUrl } from '~/utilities/getPropertyUrl';

export function usePropertyUrl(trailingSlash = false): string {
  const {
    payloadToSSR: { editionEndpoint, propertyEndpoint },
  } = useContext(AppDataContext);

  return getPropertyUrl(editionEndpoint, propertyEndpoint, trailingSlash);
}
